import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(string: string, limit: number): string {
    // Added validation for string not defined
    return string && string.length > limit ? string.substring(0, limit - 3) + '...' : string;
  }
}
